import { findIndex, snakeCase, isPlainObject, camelCase } from "lodash";

export const sortCollectionByNumberField = (
  collection: Array<{
    [key: string]: number;
  }> | null,
  field: string
) => {
  if (collection) {
    return [...collection].sort((prev, next) => prev[field] - next[field]);
  } else {
    return [];
  }
};

export const sortCollectionByName = (
  collection: Array<{
    [key: string]: string;
  }> | null
) => {
  if (collection) {
    return [...collection].sort((prev, next) =>
      prev.name.localeCompare(next.name)
    );
  } else {
    return [];
  }
};

export const sortModalItemsAlphabetically = (modalItems: Array<ModalItem>) =>
  modalItems.sort((prev, next) => prev.text.localeCompare(next.text));

export const updateFieldObjInArrayIfFound = (
  arr: Array<{
    [key: string]: any;
  }>,
  findFunc: (item: { [key: string]: any }) => boolean,
  updateField: string,
  updateValue: any
) => {
  const idx = findIndex(arr, findFunc);
  if (idx === -1) return arr; // Not found, return original array

  // return a new array with the updated value
  return [
    ...arr.slice(0, idx),
    {
      ...arr[idx],
      [updateField]: updateValue,
    },
    ...arr.slice(idx + 1),
  ];
};

export const updateOrAppendFieldObjInArrayIfFound = (
  arr: Array<{
    [key: string]: any;
  }>,
  findFunc: (item: { [key: string]: any }) => boolean,
  updateField: string,
  updateValue: any
) => {
  const idx = findIndex(arr, findFunc);
  if (idx === -1) {
    return [
      ...arr,
      {
        [updateField]: updateValue,
      },
    ];
  }
  return [
    ...arr.slice(0, idx),
    {
      ...arr[idx],
      [updateField]: updateValue,
    },
    ...arr.slice(idx + 1),
  ];
};

type AnyObject = { [key: string]: any };

export const deepSnakeCaseKeys = <T>(obj: T): T => {
  if (Array.isArray(obj)) {
    // Recursively process each element in the array
    return obj.map(deepSnakeCaseKeys) as unknown as T;
  } else if (isPlainObject(obj)) {
    // Process plain objects only
    const result: AnyObject = {};
    for (const [key, value] of Object.entries(obj as Record<string, any>)) {
      const snakeKey = snakeCase(key);
      result[snakeKey] = deepSnakeCaseKeys(value);
    }
    return result as T;
  }
  // Return primitives and other types as is
  return obj;
};

export const deepCamelCaseKeys = <T>(obj: T): T => {
  if (Array.isArray(obj)) {
    return obj.map(deepCamelCaseKeys) as unknown as T;
  } else if (isPlainObject(obj)) {
    const result: AnyObject = {};
    for (const [key, value] of Object.entries(obj as Record<string, any>)) {
      const camelKey = camelCase(key);
      result[camelKey] = deepCamelCaseKeys(value);
    }
    return result as T;
  }
  return obj;
};
